import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';

export const useGetLocations = () => {
  const locationsQuery = graphql(`
    query locations {
      locations {
        id
        name
        code
        branchCode
      }
    }
  `);

  return useGraphqlQuery(locationsQuery, ['locations']);
};

export const useGetBuyListLocations = () => {
  const buyListLocationsQuery = graphql(`
    query BuyListLocations {
      buyListLocations {
        id
        code
        name
        branchCode
        facility {
          id
          code
          address {
            addressLine1
            addressLine2
            city
            region
            zipCode
          }
        }
      }
    }
  `);

  return useGraphqlQuery(buyListLocationsQuery, ['buyListLocations']);
};

export const useUpsertLocation = () => {
  const upsertLocationMutation = graphql(`
    mutation UpsertLocation($id: ID, $facilityId: ID, $input: LocationInput!) {
      upsertLocation(id: $id, facilityId: $facilityId, input: $input) {
        id
        name
        code
        branchCode
      }
    }
  `);
  return useGraphqlMutation(upsertLocationMutation, [
    'organizationFacilitiesPage',
    'organizationLocationsPage',
    'organizationFacilities',
    'locations',
    'uniqueLocationsWithInventory',
    'buyerInventoryLocations',
    'cur',
  ]);
};

export const useDeleteLocation = () => {
  const deleteLocationMutation = graphql(`
    mutation DeleteLocation($id: ID!) {
      deleteLocation(id: $id)
    }
  `);
  return useGraphqlMutation(deleteLocationMutation, [
    'organizationFacilitiesPage',
    'organizationLocationsPage',
    'organizationFacilities',
    'locations',
    'uniqueLocationsWithInventory',
    'buyerInventoryLocations',
    'cur',
  ]);
};

export const useAssignCurrentUserToLocation = () => {
  const assignCurrentUserToLocationMutation = graphql(`
    mutation AssignCurrentUserToLocation($locationId: ID!) {
      assignCurrentUserToLocation(locationId: $locationId) {
        id
        name
        code
        branchCode
      }
    }
  `);
  return useGraphqlMutation(assignCurrentUserToLocationMutation, [
    'cur',
    'organizationLocationsPage',
  ]);
};

export const useUnassignUserFromLocation = () => {
  const unassignUserFromLocationMutation = graphql(`
    mutation UnassignUserFromLocation($locationId: ID!) {
      unassignUserFromLocation(locationId: $locationId) {
        id
        name
        code
        branchCode
      }
    }
  `);
  return useGraphqlMutation(unassignUserFromLocationMutation, [
    'cur',
    'organizationLocationsPage',
  ]);
};
